/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from "react";
import { withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow } from "react-google-maps";
import Cookies from "js-cookie";

import Headline from "../../Atoms/Headline";
import Text from "../../Atoms/Text";
// import LinkSwitcher from "../../Atoms/Link/LinkSwitcher";

import { parseCookies, isMobile } from "../../../Utils/FunctionalUtils";

/**
 * full size component
 *
 * @returns {JSX.Element}
 * @constructor
 */
const GoogleMapComponent = withScriptjs(
  withGoogleMap(
    ({
      styleOptions,
      properties: { markers, icon, centerLat, centerLng, defaultZoom, animation },
    }) => {
      const [activeInfo, setActiveInfo] = useState("");
      const [currentZoom, setCurrentZoom] = useState(10);

      useEffect(() => {
        if (!animation.googleMap.default || isMobile()) {
          setCurrentZoom(+defaultZoom);
        } else {
          const revealHandler = () => {
            setCurrentZoom(+defaultZoom);
          };

          document.addEventListener("aos:in:google-map", revealHandler);
        }
      }, [animation, defaultZoom, setCurrentZoom]);

      let defaultCenter = { lat: -34.397, lng: 150.644 };

      if (centerLat && centerLng) {
        defaultCenter = { lat: +centerLat, lng: +centerLng };
      }

      let markerIcon = null;

      if (icon) {
        markerIcon = { url: icon.publicUrl };
      }

      const renderMarkers = () => {
        return markers.map((marker) => {
          return (
            <Marker
              key={`key_${marker.latitude}_${marker.longitude}`}
              icon={markerIcon}
              position={{ lat: +marker.latitude, lng: +marker.longitude }}
              onClick={() => setActiveInfo(`${marker.latitude}_${marker.longitude}`)}
            >
              {activeInfo === `${marker.latitude}_${marker.longitude}` && (
                <InfoWindow onCloseClick={() => setActiveInfo("")}>
                  <>
                    <Headline headerType="h5" headline={marker.header} />

                    {marker.info && (
                      <div className="mt-xsmall">
                        <Text textType="html" text={marker.info} />
                      </div>
                    )}

                    {marker.link && (
                      <div className="mt-xsmall">
                        <a href={marker.link.url} className="link-primary">
                          {marker.link.title}
                        </a>
                        {/* <LinkSwitcher linkType="link-primary" link={marker.link} /> */}
                      </div>
                    )}
                  </>
                </InfoWindow>
              )}
            </Marker>
          );
        });
      };

      return (
        <GoogleMap
          defaultZoom={+defaultZoom}
          defaultCenter={defaultCenter}
          defaultOptions={{ styles: styleOptions }}
          zoom={currentZoom}
        >
          {renderMarkers()}
        </GoogleMap>
      );
    },
  ),
);

const StandardGoogleMaps = (props) => {
  const hasCookiebot = document.getElementById("Cookiebot");
  const parsedCookies = parseCookies(Cookies.get("CookieConsent"));

  if (hasCookiebot && (!parsedCookies.statistics || !parsedCookies.marketing)) {
    return null;
  }

  return (
    <div
      className="google-maps standard"
      data-aos-anchor-placement="center-center"
      data-aos="none"
      data-aos-id="google-map"
    >
      <div className="row">
        <div className="col-12">
          <GoogleMapComponent {...props} />
        </div>
      </div>
    </div>
  );
};
export default StandardGoogleMaps;
